module.exports = __webpack_public_path__ + "img/w-trakcie.00eb2203.svg";